import { render, staticRenderFns } from "./PlanSelect.vue?vue&type=template&id=2cfb8c20&scoped=true"
import script from "./PlanSelect.vue?vue&type=script&lang=js"
export * from "./PlanSelect.vue?vue&type=script&lang=js"
import style0 from "./PlanSelect.vue?vue&type=style&index=0&id=2cfb8c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb8c20",
  null
  
)

export default component.exports